module.exports = `:root {
  --primitiveColorNeutral25: #090909;
  --primitiveColorNeutral50: #111111;
  --primitiveColorNeutral100: #1b1b1b;
  --primitiveColorNeutral150: #262626;
  --primitiveColorNeutral200: #303030;
  --primitiveColorNeutral250: #3b3b3b;
  --primitiveColorNeutral300: #474747;
  --primitiveColorNeutral350: #525252;
  --primitiveColorNeutral400: #5e5e5e;
  --primitiveColorNeutral450: #6a6a6a;
  --primitiveColorNeutral550: #848484;
  --primitiveColorNeutral600: #919191;
  --primitiveColorNeutral650: #9e9e9e;
  --primitiveColorNeutral700: #ababab;
  --primitiveColorNeutral750: #b9b9b9;
  --primitiveColorNeutral850: #d4d4d4;
  --primitiveColorNeutral900: #e2e2e2;
  --primitiveColorNeutral950: #f1f1f1;
  --primitiveColorNeutral975: #f8f8f8;
  --primitiveColorNeutral1000: #ffffff;
  --primitiveColorFunctionalError50: #1f0b04;
  --primitiveColorFunctionalError100: #331108;
  --primitiveColorFunctionalError150: #48140b;
  --primitiveColorFunctionalError200: #5e160e;
  --primitiveColorFunctionalError250: #75160f;
  --primitiveColorFunctionalError500: #c35542;
  --primitiveColorFunctionalError750: #e9aa9c;
  --primitiveColorFunctionalError850: #f4cbc3;
  --primitiveColorFunctionalError900: #f8ddd6;
  --primitiveColorFunctionalError950: #fceeeb;
  --primitiveColorFunctionalError975: #fef6f5;
  --primitiveColorFunctionalWarning50: #161002;
  --primitiveColorFunctionalWarning100: #231a04;
  --primitiveColorFunctionalWarning150: #302405;
  --primitiveColorFunctionalWarning200: #3e2e06;
  --primitiveColorFunctionalWarning250: #4b3908;
  --primitiveColorFunctionalWarning500: #977110;
  --primitiveColorFunctionalWarning750: #eaaf18;
  --primitiveColorFunctionalWarning850: #fccf5a;
  --primitiveColorFunctionalWarning900: #fde095;
  --primitiveColorFunctionalWarning950: #fef0cb;
  --primitiveColorFunctionalWarning975: #fff8e5;
  --primitiveColorFunctionalInfo50: #001224;
  --primitiveColorFunctionalInfo100: #001c39;
  --primitiveColorFunctionalInfo150: #00264d;
  --primitiveColorFunctionalInfo200: #003062;
  --primitiveColorFunctionalInfo250: #003b77;
  --primitiveColorFunctionalInfo500: #3d7ab9;
  --primitiveColorFunctionalInfo750: #9dbcdc;
  --primitiveColorFunctionalInfo850: #c4d6ea;
  --primitiveColorFunctionalInfo900: #d8e4f1;
  --primitiveColorFunctionalInfo950: #ebf1f8;
  --primitiveColorFunctionalInfo975: #f5f8fb;
  --primitiveColorFunctionalFocus50: #111019;
  --primitiveColorFunctionalFocus100: #1b1a2a;
  --primitiveColorFunctionalFocus150: #24233c;
  --primitiveColorFunctionalFocus200: #2e2d4f;
  --primitiveColorFunctionalFocus250: #373663;
  --primitiveColorFunctionalFocus500: #7571a7;
  --primitiveColorFunctionalFocus750: #b9b5d3;
  --primitiveColorFunctionalFocus850: #d5d2e4;
  --primitiveColorFunctionalFocus900: #e3e1ed;
  --primitiveColorFunctionalFocus950: #f1f0f6;
  --primitiveColorFunctionalFocus975: #f8f7fb;
  --primitiveColorProductExtras380: #7C3E98;
  --primitiveColorPrimary25: #030B08;
  --primitiveColorPrimary50: #09130f;
  --primitiveColorPrimary100: #101e19;
  --primitiveColorPrimary150: #122a21;
  --primitiveColorPrimary200: #13362a;
  --primitiveColorPrimary275: #144a38;
  --primitiveColorPrimary830: #82e578;
  --primitiveColorPrimary850: #9de782;
  --primitiveColorPrimary900: #bef0ad;
  --primitiveColorPrimary950: #dff8d6;
  --primitiveColorPrimary975: #effceb;
  --primitiveColorSage50: #10110f;
  --primitiveColorSage100: #1a1c19;
  --primitiveColorSage150: #242722;
  --primitiveColorSage200: #2e312b;
  --primitiveColorSage250: #383d35;
  --primitiveColorSage750: #adbea1;
  --primitiveColorSage835: #c2d6b5;
  --primitiveColorSage900: #dae6d2;
  --primitiveColorSage950: #edf3e8;
  --primitiveColorSage975: #f6f9f4;
  --primitiveColorWarm50: #111110;
  --primitiveColorWarm100: #1c1b1a;
  --primitiveColorWarm150: #262623;
  --primitiveColorWarm200: #31302c;
  --primitiveColorWarm250: #3d3b36;
  --primitiveColorWarm750: #bebaa7;
  --primitiveColorWarm850: #d9d5be;
  --primitiveColorWarm900: #e8e3ca;
  --primitiveColorWarm950: #f5f0d6;
  --primitiveColorWarm975: #fbf8ec;
  --primitiveColorSunset50: #13100f;
  --primitiveColorSunset100: #1e1b19;
  --primitiveColorSunset150: #2a2521;
  --primitiveColorSunset200: #362f2a;
  --primitiveColorSunset250: #433a34;
  --primitiveColorSunset750: #d3b29d;
  --primitiveColorSunset850: #f2cdb4;
  --primitiveColorSunset900: #fdd6bc;
  --primitiveColorSunset950: #ffede2;
  --primitiveColorSunset975: #fff6f1;
  --primitiveTypographyTypescaleDesktop1: 3.375rem;
  --primitiveTypographyTypescaleDesktop2: 2.25rem;
  --primitiveTypographyTypescaleDesktop3: 1.5rem;
  --primitiveTypographyTypescaleDesktop4: 1.25rem;
  --primitiveTypographyTypescaleDesktop5: 1.125rem;
  --primitiveTypographyTypescaleDesktop6: 1rem;
  --primitiveTypographyTypescaleDesktop7: 0.875rem;
  --primitiveTypographyFontWeightSans: 400;
  --primitiveTypographyFontWeightSansSemibold: 600;
  --primitiveTypographyFontWeightSansBold: 700;
  --primitiveTypographyFontWeightSerifSemibold: 600;
}
`;